import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNavigationStore = defineStore('navigation', () =>
{
    const isSitemapNavigation = ref(false);

    const setSitemapNavigation = (value: boolean) =>
    {
        isSitemapNavigation.value = value;
    };

    const clearSitemapNavigation = () =>
    {
        isSitemapNavigation.value = false;
    };

    return {
        isSitemapNavigation,
        setSitemapNavigation,
        clearSitemapNavigation
    };
});
